export default {
  MULTIPLE_CHOICE: {
    DEFAULT_OPTIONS: ['sì', 'no'],
    OFFLINE_MESSAGE:
      'Chiedo scusa ma non sono connessa alla rete internet. Non posso elbarorare la tua risposta.'
  }
}
